import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: number; // 0 = Student, 1 = Instructor, 2 = Admin, 3 = Moderator
}

export default function ProtectedRoute({
  children,
  requiredRole,
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <FontAwesomeIcon icon={faSpinner} className="h-12 w-12 text-brand-600 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }

  if (requiredRole !== undefined && user?.role !== requiredRole) {
    const home =
      user?.role === 2
        ? '/admin/dashboard'
        : user?.role === 1
          ? '/instructor/dashboard'
          : user?.role === 3
            ? '/moderator/dashboard'
            : '/dashboard';
    return <Navigate to={home} replace />;
  }

  return <>{children}</>;
}
